import React from "react";
import { useTranslation } from "react-i18next";
import { ChevronDown, ChevronUp, Pencil, Trash2 } from "lucide-react";
import TeacherDetails from "./TeacherDetails";

const TeacherTable = ({
  loading,
  filteredTeachers,
  expandedRowIndex,
  selectedTeachers,
  handleEdit,
  handleDelete,
  toggleView,
  toggleTeacherSelection,
  toggleSelectAll,
}) => {
  const { t } = useTranslation();

  if (loading) {
    return (
      <div className="flex justify-center items-center h-40">
        <div className="spinner-border animate-spin inline-block w-8 h-8 border-4 rounded-full text-[#241763]"></div>
        <span className="ml-2 text-[#241763]">{t("Loading")}...</span>
      </div>
    );
  }

  return (
    <div className="max-h-[70vh] overflow-x-auto overflow-y-auto">
      <table className="table-auto h-90 w-full mt-6">
        <thead className="py-4 border-b font-bold">
          <tr>
            <th>
              <input
                type="checkbox"
                checked={selectedTeachers.length > 0 && selectedTeachers.length === filteredTeachers.length}
                onChange={toggleSelectAll}
              />
            </th>
            <th>{t("Profile")}</th>
            <th>{t("Name")}</th>
            <th>{t("Gender")}</th>
            <th>{t("Email")}</th>
            <th>{t("Phone")}</th>
            <th>{t("EmployeeCode")}</th>
            <th>{t("Status")}</th>
            <th>{t("Actions")}</th>
          </tr>
        </thead>
        <tbody className="text-sm">
          {filteredTeachers.map((teacher, index) => (
            <React.Fragment key={teacher.teacher?.id}>
              <tr className="p-2 py-2 hover:bg-gray-200 space-y-2">
                <td>
                  <input
                    type="checkbox"
                    checked={selectedTeachers.some((t) => t.id === teacher.teacher?.id)}
                    onChange={() =>
                      toggleTeacherSelection(
                        teacher.teacher?.id,
                        `${teacher.teacher?.firstName} ${teacher.teacher?.lastName}`
                      )
                    }
                  />
                </td>
                <td>
                  <img
                    src={teacher.teacher?.profilePicture}
                    alt={t("TeacherProfile")}
                    className="w-8 h-8 sm:w-10 sm:h-10 rounded-full"
                  />
                </td>
                <td>{`${teacher.teacher?.firstName} ${teacher.teacher?.lastName}`}</td>
                <td>{teacher.teacher?.gender}</td>
                <td>{teacher.teacher?.email}</td>
                <td className="text-blue-500">{teacher.teacher?.phone}</td>
                <td>{teacher.teacher?.employeeCode}</td>
                <td>{teacher.teacher?.userStatus}</td>
                <td className="space-x-2 flex items-center py-2">
                  <button
                    className="bg-[#B6A5C9]/50 text-white p-2 rounded mr-2 hover:bg-[#241763]/60 group"
                    onClick={() => handleEdit(teacher.teacher?.id)}
                  >
                    <Pencil className="text-[#241763] w-4 h-4 group-hover:text-white" />
                  </button>
                  <button
                    className="bg-[#B6A5C9]/50 text-white p-2 rounded hover:bg-[#241763]/60 group"
                    onClick={() => handleDelete(teacher.teacher?.id)}
                  >
                    <Trash2 className="text-[#241763] w-4 h-4 group-hover:text-white" />
                  </button>
                  <div
                    onClick={() => toggleView(index)}
                    className="cursor-pointer hover:bg-[#241763]/60 group bg-[#B6A5C9]/50 p-2 rounded"
                  >
                    {expandedRowIndex === index ? (
                      <ChevronUp size={16} className="group-hover:text-white" />
                    ) : (
                      <ChevronDown size={16} className="group-hover:text-white" />
                    )}
                  </div>
                </td>
              </tr>
              {expandedRowIndex === index && (
                <tr>
                  <td colSpan="10">
                    <TeacherDetails teacher={teacher} />
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TeacherTable; 